module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Home */

(function(fox) {
	fox.registerWidget('Layout_Join', {

		//Widget config
		configure: function(options) {
			this.callParent('configure', arguments);
			this.sitePageContainer = '#main';
		},

		//Widget run
		run: function() {
			if (!this.callParent('run', arguments)) return;
			delete this.sitePageFragment;
			this.renderState = 0;
			this.fragment = fox.createFragmentFromHtml(this.options.dataLayer.getObject().get('template'));

			this.render();
			return this;
		},

		sitePageReady: function(sitePageFragment) {
			if (this.renderState == 1) {
				this.renderSitePage(document.body, sitePageFragment);
			}
			this.sitePageFragment = sitePageFragment;
		},

		render: function() {
			if (this.sitePageFragment) {
				this.renderSitePage(this.fragment, this.sitePageFragment);
			}
			document.body.innerHTML = '';
			document.body.appendChild(this.fragment);
			this.renderState = 1;
		},

		renderSitePage: function(container, fragment) {
			var sitePageContainer = fox.dom.select(this.sitePageContainer, container)[0];
			sitePageContainer.innerHTML = '';
			sitePageContainer.appendChild(fragment);
		}
	}, fox.Layout);

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/layout/join.js
// module id = 123
// module chunks = 4